import Breadcrumb from "../../Component/Breadcrumb";

function SchoolUniform() {
  return (
    <>
      <Breadcrumb>Policies / School Dress</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>School Dress</h1>
          </div>
          <div className="uniform-section ">
            {/* ===================== LKG – CLASS V ===================== */}
            <div className="uniform-group mb-5">
              <h2 className="uniform-title">LKG – Class V</h2>

              {/* Summer Uniform */}
              <div className="uniform-category">
                <h4 className="uniform-heading">Summer Uniform</h4>
                <div className="row g-3 align-items-stretch">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        Navy blue long pants, white shirt (half sleeves), school
                        tie, school belt, black laced leather shoes and navy
                        blue socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        V-neck navy blue tunic, white shirt (half sleeves),
                        school tie, school belt, black leather shoes and navy
                        blue socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Winter Uniform */}
              <div className="uniform-category">
                <h4 className="uniform-heading">Winter Uniform</h4>
                <div className="row g-3 align-items-stretch">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        Navy blue long pants, white shirt (full sleeves), V-neck
                        maroon half sweater with one yellow stripe on neck,
                        sleeves and border, Maroon blazer with school monogram,
                        school tie, belt, black leather shoes and navy blue
                        socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        V-neck navy blue tunic, white shirt (full sleeves),
                        V-neck maroon half sweater with one yellow stripe on
                        neck, sleeves and border, Maroon blazer with school
                        monogram, school tie, belt, black leather shoes and navy
                        blue stockings.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* PT Dress */}
              <div className="uniform-category">
                <h4 className="uniform-heading">P.T. Dress (Saturday)</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        White long pants, white shirt (half sleeves), school
                        tie, belt, white canvas shoes and white socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        V-neck white tunic, white shirt (half sleeves), school
                        tie, belt, white canvas shoes and white socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* House Uniform */}
              <div className="uniform-category">
                <h4 className="uniform-heading">House Uniform (Wednesday)</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        White long pants, color T-shirt according to the house
                        with school monogram, belt, white canvas shoes and white
                        socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        V-neck white tunic, color T-shirt according to the house
                        with school monogram, belt, white canvas shoes and white
                        socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===================== VI – X ===================== */}
            <div className="uniform-group mb-5">
              <h2 className="uniform-title">
                Junior & Secondary Section (VI – X)
              </h2>

              {/* Summer */}
              <div className="uniform-category">
                <h4 className="uniform-heading">Summer Uniform</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        Navy blue long pants (low waist not permitted), white
                        shirt (half sleeves), school tie, belt, black leather
                        shoes and navy blue socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        Navy blue skirt, white shirt (half sleeves), school tie,
                        belt, black leather shoes and navy blue stockings.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Winter */}
              <div className="uniform-category">
                <h4 className="uniform-heading">Winter Uniform</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        Navy blue pants (low waist not permitted), white shirt
                        (full sleeves), school tie, belt, maroon half sweater
                        with yellow stripe, Maroon blazer with school monogram,
                        black shoes, navy blue socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        Navy blue skirt, white shirt (full sleeves), maroon
                        sweater with yellow stripe, Maroon blazer with monogram,
                        school tie, belt, black shoes and navy blue stockings.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* PT */}
              <div className="uniform-category">
                <h4 className="uniform-heading">P.T. Dress (Saturday)</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        White long pants, white shirt (half sleeves), school
                        tie, belt, white canvas shoes and white socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        White skirt, white shirt (half sleeves), school tie,
                        belt, white canvas shoes and white stockings.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* House */}
              <div className="uniform-category">
                <h4 className="uniform-heading">House Uniform (Wednesday)</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        White long pants, color T-shirt according to house with
                        school monogram, white canvas shoes and white socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        White skirt, color T-shirt according to house with
                        school monogram, white canvas shoes and white stockings.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===================== XI – XII ===================== */}
            <div className="uniform-group mb-5">
              <h2 className="uniform-title">Senior Section (XI – XII)</h2>

              {/* Summer */}
              <div className="uniform-category">
                <h4 className="uniform-heading">Summer Uniform</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        Navy blue long pants (low waist not permitted), white
                        shirt (half sleeves), school tie, belt, black leather
                        shoes and navy blue socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        Sky blue checked suit with chest coat and white salwar,
                        black leather shoes and navy blue socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Winter */}
              <div className="uniform-category">
                <h4 className="uniform-heading">Winter Uniform</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        Navy blue pants (low waist not permitted), white shirt,
                        school tie, belt, maroon half sweater with yellow
                        stripe, Maroon blazer with monogram, black shoes and
                        navy blue socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        Sky blue checked suit with chest coat and white salwar,
                        maroon sweater with yellow stripe, maroon blazer with
                        monogram, black shoes and navy blue socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* PT */}
              <div className="uniform-category">
                <h4 className="uniform-heading">P.T. Dress (Saturday)</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        White long pants, white shirt (half sleeves), school
                        tie, belt, white canvas shoes and white socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        White salwar kameez with coatee, white canvas shoes and
                        white socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* House */}
              <div className="uniform-category">
                <h4 className="uniform-heading">House Uniform (Wednesday)</h4>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="uniform-card boys-card">
                      <h5>Boys</h5>
                      <p>
                        T-shirts as per house color with school monogram, white
                        long pants, white canvas shoes and white socks.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="uniform-card girls-card">
                      <h5>Girls</h5>
                      <p>
                        White salwar kameez with coatee, white canvas shoes and
                        white socks.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===================== Final Notes ===================== */}
            <div className="uniform-note mt-5">
              <h4>The School Uniform Must Be Neat and Clean</h4>
              <p>
                Students who fail to be in uniform as required or those who come
                in shabby and untidy dress will be denied entry into the class
                and are liable to be sent home.
              </p>

              <h4 className="mt-4">Hairstyle</h4>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="uniform-card boys-card">
                    <h5>Boys</h5>
                    <p>
                      Should have short hair and shall not follow any modern
                      trend.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="uniform-card girls-card">
                    <h5>Girls</h5>
                    <p>Should plait their hair neatly into two sections.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SchoolUniform;
